import { Box, Flex, Heading, Stack, useColorModeValue } from '@chakra-ui/react'
import React from 'react';
import ResetPasswordForm from '../../components/forms/auth/ResetPasswordForm';

export default function ChangeDefaultPassword() {
    return (
        <Flex
            minH={'100vh'}
            align={'center'}
            justify={'center'}
            bg={useColorModeValue('gray.50', 'gray.800')}
        >
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                <Stack align={'center'}>
                    <Heading fontSize={'4xl'}>パスワードリセット</Heading>
                </Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}
                >
                    <ResetPasswordForm />
                </Box>
            </Stack>
        </Flex>
    )
}
